export default function HandphoneIcon({
  size = 40,
  fill = 'none',
  fillItem = '#4F4C4D',
}: {
  size?: number;
  fill?: string;
  fillItem?: string;
}) {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6673 0.667969H5.33398C4.22732 0.667969 3.33398 1.5613 3.33398 2.66797V13.3346C3.33398 14.4413 4.22732 15.3346 5.33398 15.3346H10.6673C11.774 15.3346 12.6673 14.4413 12.6673 13.3346V2.66797C12.6673 1.5613 11.774 0.667969 10.6673 0.667969ZM9.00065 14.0013H7.00065C6.81398 14.0013 6.66732 13.8546 6.66732 13.668C6.66732 13.4813 6.81398 13.3346 7.00065 13.3346H9.00065C9.18732 13.3346 9.33398 13.4813 9.33398 13.668C9.33398 13.8546 9.18732 14.0013 9.00065 14.0013ZM11.334 12.0013H4.66732V2.66797H11.334V12.0013Z"
          fill={fillItem}
        />
      </svg>
    </>
  );
}
